export const setAuthNav = () => {
  const navElement = document.getElementById('bsd-global-nav');
  const cimaToken = localStorage.getItem('cb.auth.default.accessToken');

  if (cimaToken) {
    navElement.setAttribute('data-auth-type', 'CIMA');
    navElement.setAttribute('data-auth-token', 'Bearer ' + cimaToken);
  }
};
